var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLandingYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 46,
    viewBox: "0 0 47 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.852219,
    y: 0.0126953,
    width: 45.9873,
    height: 45.9873,
    rx: 4,
    fill: "#F1F1F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4062 31.9225L19.2171 31.8255C17.537 31.7918 15.8526 31.8592 14.2055 31.5091C11.6997 30.986 11.5222 28.421 11.3364 26.2695C11.0805 23.2448 11.1796 20.1652 11.6626 17.1657C11.9353 15.4826 13.0083 14.4784 14.6678 14.3691C20.2698 13.9725 25.909 14.0195 31.4985 14.2045C32.0888 14.2215 32.6832 14.3142 33.2653 14.4197C36.1386 14.9344 36.2087 17.8411 36.395 20.2879C36.5807 22.76 36.5023 25.2448 36.1473 27.7001C35.8624 29.733 35.3175 31.4377 33.0176 31.6023C30.136 31.8175 27.3206 31.9908 24.4309 31.9356C24.4311 31.9225 24.4145 31.9225 24.4062 31.9225ZM21.3555 26.7758C23.527 25.5017 25.6571 24.2488 27.8162 22.9832C25.6406 21.7091 23.5146 20.4562 21.3555 19.1907V26.7758Z",
    fill: "#545454"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandingYoutube);
export default __webpack_public_path__ + "static/media/landingYoutube.64d4967f831181f7d41576a5c19773a0.svg";
export { ForwardRef as ReactComponent };